import axios from 'axios';
import Common from '../Common';
import { store } from '../store';
import { setHaveUnreadMessage } from '../components/NoticeBox/noticeSlice';

const axiosClient = axios.create({
    baseURL: Common.API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
})

// Interceptors
// Add a request interceptor
axiosClient.interceptors.request.use(
    async function (config) {
        // const { latitude, longitude } = await Common.getPosition();
        const { latitude, longitude } = ["", ""];
        const { cUser, cToken } = Common.localStorageGetToken();
        config.headers['C-User'] = cUser;
        config.headers['C-Token'] = cToken;
        config.headers['Latitude'] = latitude;
        config.headers['Longitude'] = longitude;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        const haveUnreadMessage = response?.data?.headers?.['HaveUnreadMessage'] ?? '0';
        const unreadCount = Number(haveUnreadMessage || 0);
        store.dispatch(setHaveUnreadMessage(unreadCount));
        Common.localStorageSetUnreadMessage(unreadCount);
        return response.data;
    },
    function (error) {
        //TODO: Catch Error
        console.log('エラー：' + error.message);
        console.log(error.response);
        if (error.response?.status === 401) {
            Common.localStorageRemoveToken();
            window.location.replace(Common.URL_LOGIN);
        }
        return Promise.reject(error);
    }
);

export default axiosClient
